import { render, staticRenderFns } from "./UseCode.vue?vue&type=template&id=404b28be&scoped=true&"
import script from "./UseCode.vue?vue&type=script&lang=js&"
export * from "./UseCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b28be",
  null
  
)

export default component.exports